import request from '@/router/axios'

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '/wage/wagebatchinfo' : '/wage/wagebatchinfo'

// 账单列表
export function queryBillListByPage(data) {
  return request({
    url: urlPrefix + '/queryBillListByPage',
    method: 'post',
    data
  })
}
